

import React, { useState, useEffect } from 'react';
import { 
  Button, 
  Input, 
  Spin, 
  Row, 
  Col, 
  Space, 
  Image,
  Tag,
  message,
  Card,
  Empty,
  Typography,
  ConfigProvider,
  InputNumber,
  Divider,
  Badge,
  Modal,
  Select,
  Pagination,
  Alert
} from 'antd';
import { 
  FaShoppingCart, 
  FaSearch, 
  FaClipboardList,
  FaCheckCircle,
  FaExclamationTriangle,
  FaFileDownload,
  FaSpinner
} from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams, useNavigate } from 'react-router-dom';
import Api from '../api/Api';
import formatarValor from '../formatarValor';

const { Title, Text } = Typography;

const TelaVendas = () => {
  const { id } = useParams();
  const { token } = useParams();
  const [mesaId, setMesaId] = useState(id);
  const [tokenId, settokenId] = useState(token);
  const navigate = useNavigate();
  
  // Estados principais
  const [produtos, setProdutos] = useState([]);
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categorias, setCategorias] = useState([]);
  
  // Estados do carrinho
  const [carrinho, setCarrinho] = useState([]);
  const [observacao, setObservacao] = useState('');
  
  // Estados para modais
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalFaturaVisible, setIsModalFaturaVisible] = useState(false);
  const [stockError, setStockError] = useState(null);

  // Estado para armazenar o ID do documento gerado
  const [documentoId, setDocumentoId] = useState(null);
  const [validandoFatura, setValidandoFatura] = useState(false);
  const [faturaPronta, setFaturaPronta] = useState(false);

  // Estados para paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);

  // Estado para controlar o processo de finalização
  const [finalizandoPedido, setFinalizandoPedido] = useState(false);

  // Estados para os modais de cliente
const [isClienteModalVisible, setIsClienteModalVisible] = useState(false);
const [isEscolhaModalVisible, setIsEscolhaModalVisible] = useState(false);
const [produtoSelecionado, setProdutoSelecionado] = useState(null);
const [nomeCliente, setNomeCliente] = useState('');
const [nifCliente, setNifCliente] = useState('');
const clienteAtivo = pedidos.length > 0 && pedidos[0].nome && pedidos[0].nif;



  // Cores do degradê
  const primaryColor = 'rgb(249, 130, 68)';
  const secondaryColor = 'rgb(247, 72, 115)';
  const gradient = `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`;

  // URL base para imagens
  
  
 // const BASE_IMAGE_URL = 'http://127.0.0.1:8000//img/';
  //const IMG_ALTERNATIVA='http://127.0.0.1:8000//img/default.png';


  const BASE_IMAGE_URL = 'https://qrorder.milvendas.ao/public/img/';
  const IMG_ALTERNATIVA='https://qrorder.milvendas.ao/public/img/default.png';
  
  useEffect(() => {
    setMesaId(id);
  }, [id]);


      useEffect(() => {
     document.title = "Vendas";
   
  }, []);

  useEffect(() => {
    settokenId(token);
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [mesaId]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const [produtosData, categoriasData, pedidosData] = await Promise.all([
        Api.ListProduto(),
        Api.ListCategoria(),
        Api.ListPedidoPorMesa({id: id,token: tokenId})
      ]);
      
      setProdutos(produtosData.map(p => ({ 
        ...p,
        key: p.id,
        qtd: parseInt(p.qtd) || 0,
        img: p.img ? (p.img.startsWith('http') ? p.img : `${BASE_IMAGE_URL}${p.img}`) : null
      })));
      
      setCategorias(categoriasData);
      
      // Filtrar apenas pedidos abertos ou pendentes
     setPedidos(
  pedidosData.filter(p => ['ABERTO', 'PENDENTE', 'PREPARACAO','ENTREGUE'].includes(p.status))
);

    } catch (error) {
      toast.error('Erro ao carregar dados: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Filtrar produtos
  const filteredProdutos = produtos.filter(produto => {
    const matchesSearch = produto.descricao.toLowerCase().includes(searchText.toLowerCase());
    const matchesCategory = selectedCategory ? Number(produto.id_categoria) === Number(selectedCategory) : true;
    const matchesStatus = produto.status?.toUpperCase() === 'DISPONÍVEL';
    
    return matchesSearch && matchesCategory && matchesStatus;
  });

  // Paginação - calcular produtos atuais
  const indexOfLastProduct = currentPage * pageSize;
  const indexOfFirstProduct = indexOfLastProduct - pageSize;
  const currentProducts = filteredProdutos.slice(indexOfFirstProduct, indexOfLastProduct);

  // Verificar se há quantidade suficiente em estoque
  const verificarEstoque = () => {
    for (const item of carrinho) {
      const produto = produtos.find(p => p.id === item.id);
      if (produto && produto.qtd < item.quantidade) {
        return {
          sucesso: false,
          produto: produto,
          quantidadeDisponivel: produto.qtd,
          quantidadeSolicitada: item.quantidade
        };
      }
    }
    return { sucesso: true };
  };

  // Adicionar produto ao carrinho
  const adicionarAoCarrinho = (produto) => {
    // Verificar se há estoque disponível
    if (produto.qtd > 0) {
      setCarrinho(prev => {
        const existe = prev.find(item => item.id === produto.id);
        if (existe) {
          // Verificar se não excede o estoque ao adicionar mais um
          if (existe.quantidade + 1 <= produto.qtd) {
            return prev.map(item =>
              item.id === produto.id 
                ? { ...item, quantidade: item.quantidade + 1 } 
                : item
            );
          } else {
            toast.warning(`Não há estoque suficiente para adicionar mais unidades de ${produto.descricao}`);
            return prev;
          }
        }
        return [...prev, { ...produto, quantidade: 1 }];
      });
    } else {
      toast.warning(`Produto ${produto.descricao} sem estoque disponível`);
    }
  };

  // Remover produto do carrinho
  const removerDoCarrinho = (produtoId) => {
    setCarrinho(prev => {
      const item = prev.find(item => item.id === produtoId);
      if (item && item.quantidade > 1) {
        return prev.map(item =>
          item.id === produtoId 
            ? { ...item, quantidade: item.quantidade - 1 } 
            : item
        );
      }
      return prev.filter(item => item.id !== produtoId);
    });
  };

  // Calcular total do carrinho
  const calcularTotal = () => {
    return carrinho.reduce((total, item) => {
      return total + (item.preco * item.quantidade);
    }, 0);
  };

  // Calcular total de pedidos ativos
  const calcularTotalPedidosAtivos = () => {
    return pedidos.reduce((total, pedido) => {
      const produto = produtos.find(p => p.id === pedido.id_produto);
      return total + (produto?.preco || 0) * pedido.quantidade;
    }, 0);
  };

// Atualizar pedidos automaticamente a cada 5s
useEffect(() => {
  const interval = setInterval(() => {
    Api.ListPedidoPorMesa({ id: mesaId, token: tokenId })
      .then((pedidosData) => {
        setPedidos(
          pedidosData.filter(p => 
            ['ABERTO','PENDENTE','PREPARACAO','ENTREGUE'].includes(p.status)
          )
        );

        // ATUALIZA TAMBÉM O NOME E NIF DO CLIENTE
        if (pedidosData.length > 0) {
          setNomeCliente(pedidosData[0].nome || "");
          setNifCliente(pedidosData[0].nif || "");
        }

      })
      .catch(() => {});
  }, 5000);

  return () => clearInterval(interval);
}, [mesaId, tokenId]);





  // Finalizar pedido (adicionar ao sistema)
  const finalizarPedido = async () => {
    try {
      setLoading(true);
      
      if (carrinho.length === 0) {
        toast.error('Adicione pelo menos um produto ao pedido');
        return;
      }

      // Verificar se há estoque suficiente para todos os itens
      const verificacaoEstoque = verificarEstoque();
      if (!verificacaoEstoque.sucesso) {
        setStockError({
          produto: verificacaoEstoque.produto.descricao,
          disponivel: verificacaoEstoque.quantidadeDisponivel,
          solicitado: verificacaoEstoque.quantidadeSolicitada
        });
        return;
      }

      // Se passou na verificação de estoque, limpar qualquer erro anterior
      setStockError(null);

      // Usar nome/NIF do primeiro pedido ativo (se existir) ou o que foi digitado
      const nomePedido = nomeCliente || (pedidos.length > 0 ? pedidos[0].nome : '');
      const nifPedido = nifCliente || (pedidos.length > 0 ? pedidos[0].nif : '');

      // Criar um pedido para cada produto no carrinho
      const pedidosPromises = carrinho.map(item => 
        Api.AddPedido({
          id_mesa: id,
          id_produto: item.id,
          quantidade: item.quantidade,
          obs: observacao,
          status: 'ABERTO',
          token: tokenId,
          nome: nomePedido,
          nif: nifPedido
        })
      );

      await Promise.all(pedidosPromises);
      
      toast.success('Pedido realizado com sucesso!');
      setCarrinho([]);
      setObservacao('');
      setIsModalVisible(false);
      
      // Atualizar a lista de pedidos ativos
      fetchData();
      
    } catch (error) {
      toast.error('Erro ao realizar pedido: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Função para verificar status do pedido
  const verificarStatusPedido = async (pedidoId) => {
    try {
      const response = await Api.CheckPedido({ id: pedidoId });
      return response;
    } catch (error) {
      console.error('Erro ao verificar status do pedido:', error);
      return null;
    }
  };

  // FINALIZAR PEDIDO - FLUXO SIMPLIFICADO
  const finalizarPedidoComDocumento = async () => {
    try {
      setFinalizandoPedido(true);
      
      // 1. Primeiro coloca todos os pedidos como PENDENTE
      
      const responsePendente = await Api.PendenteAll({ id: mesaId });
      
      if (responsePendente.success) {
        toast.success('Pedido finalizado com sucesso!');
        
        // 2. Abrir modal para gerar fatura
        setIsModalFaturaVisible(true);
        setFaturaPronta(false);
        setDocumentoId(null);
        
        // 3. Atualizar os dados para limpar os pedidos ativos
        fetchData();
      } else {
        toast.error('Erro ao finalizar pedido: ' + responsePendente.message);
      }
      
    } catch (error) {
      toast.error('Erro ao finalizar pedido: ' + error.message);
    } finally {
      setFinalizandoPedido(false);
    }
  };

  // VALIDAR E GERAR FATURA - FLUXO CORRETO
  const validarEGerarFatura = async () => {
    try {
      setValidandoFatura(true);
      
      // Buscar os pedidos atualizados da mesa
      const pedidosAtualizados = await Api.ListPedidoPorMesa({ id: mesaId,token: tokenId });
      const pedidosPendentes = pedidosAtualizados.filter(p => p.status === 'PENDENTE' || p.status === 'FECHADO' ||p.status === 'PREPARACAO' ||p.status === 'ENTREGUE');
      
      if (pedidosPendentes.length === 0) {
        toast.error('Nenhum pedido encontrado para gerar fatura');
        setValidandoFatura(false);
        return;
      }

      // Verificar o status de cada pedido pendente
      let faturaGerada = false;
      
      for (const pedido of pedidosPendentes) {
        const statusCheck = await verificarStatusPedido(mesaId);
        
     
        if (statusCheck && statusCheck.status === 'FECHADO' && statusCheck.id_doc) {
          // Se encontrou um pedido fechado com ID_DOC, usar para gerar a fatura
          setDocumentoId(statusCheck.id_doc);
          setFaturaPronta(true);
          faturaGerada = true;
          toast.success('Fatura gerada com sucesso!');
          break;
        }
      }
      
      if (!faturaGerada) {
        toast.warning('A fatura ainda não está pronta. Aguarde o processamento.');
      }
      
    } catch (error) {
      toast.error('Erro ao validar fatura: ' + error.message);
    } finally {
      setValidandoFatura(false);
    }
  };




  // Abrir fatura em nova aba
  const abrirFatura = () => {
    if (documentoId) {
      window.open(`https://socialite.milvendas.ao/factura/${documentoId}`, '_blank');
      setIsModalFaturaVisible(false);
      // Resetar estados
      setFaturaPronta(false);
      setDocumentoId(null);
    }
  };

  // Fechar modal de fatura
  const fecharModalFatura = () => {
    setIsModalFaturaVisible(false);
    setFaturaPronta(false);
    setDocumentoId(null);
    setValidandoFatura(false);
  };

  // Renderizar status do pedido
  const renderStatusTag = (status) => {
    let color = '';
    let text = '';
    
    switch(status) {
      case 'ABERTO':
        color = 'blue';
        text = 'Aberto';
        break;
      case 'PENDENTE':
        color = 'orange';
        text = 'Pendente';
        break;
      case 'FECHADO':
        color = 'green';
        text = 'Fechado';
        break;
      case 'PREPARACAO':
        color = 'gray';
        text = 'Em preparação';
        break;
        case 'ENTREGUE':
        color = 'gray';
        text = 'Entregue';
        break;



      default:
        color = 'gray';
        text = status;
    }
    
    return (
      <Tag color={color}>
        {text}
      </Tag>
    );
  };

  // Layout responsivo
  const responsiveLayout = {
    productsCol: { xs: 24, sm: 24, md: 16, lg: 16, xl: 16 },
    ordersCol: { xs: 24, sm: 24, md: 8, lg: 8, xl: 8 }
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: primaryColor,
          borderRadius: 8,
        },
      }}
    >
      <div style={{ 
        padding: '16px 12px',
        background: '#f8f9fa',
        minHeight: '100vh'
      }}>
        <ToastContainer position="top-right" />
        
        {/* Cabeçalho */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          marginBottom: 16,
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 8
        }}>
          <Title level={2} style={{ 
            margin: 0,
            fontSize: '1.5rem',
            background: gradient,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            MESA {mesaId} - FAZER PEDIDO
          </Title>
          
          <div style={{ 
            display: 'flex', 
            gap: 8, 
            flexWrap: 'wrap',
            width: '100%',
            marginTop: 8
          }}>
            <div style={{ flex: 1, minWidth: 200 }}>
              <Input
                placeholder="Pesquisar produtos..."
                prefix={<FaSearch style={{ color: 'rgba(0,0,0,0.3)' }} />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ 
                  width: '100%',
                  borderRadius: 8,
                  border: '1px solid rgba(0,0,0,0.1)'
                }}
              />
            </div>
            
            <div style={{ flex: 1, minWidth: 160 }}>
              <Select
                placeholder="Selecionar categoria"
                options={[
                  { value: null, label: 'Todos' },
                  ...categorias.map(c => ({ value: c.id, label: c.descricao }))
                ]}
                value={selectedCategory}
                onChange={setSelectedCategory}
                style={{ width: '100%', borderRadius: 8 }}
                allowClear
              />
            </div>
            
            <div style={{ flex: 0 }}>
              <Badge 
                count={carrinho.reduce((total, item) => total + item.quantidade, 0)} 
                style={{ backgroundColor: primaryColor }}
              >
                <Button 
                  type="primary"
                  icon={<FaShoppingCart />}
                  onClick={() => setIsModalVisible(true)}
                  style={{ 
                    background: gradient,
                    border: 'none',
                    borderRadius: 8,
                    boxShadow: '0 4px 12px rgba(247, 72, 115, 0.3)',
                    height: 40,
                    display: 'flex',
                    alignItems: 'center',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <span className="hide-on-mobile">Ver Carrinho</span>
                  <span className="show-on-mobile" style={{ display: 'none' }}>Carrinho</span>
                </Button>
              </Badge>
            </div>
          </div>
        </div>

        <Row gutter={[16, 16]}>
          {/* Lista de Produtos */}
          <Col {...responsiveLayout.productsCol}>
            <Spin spinning={loading}>
              {currentProducts.length > 0 ? (
                <>
                  <div style={{ 
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                    gap: 16
                  }}>
                    {currentProducts.map(produto => (
                      <Card
                        key={produto.id}
                        hoverable
                        style={{
                          borderRadius: 12,
                          overflow: 'hidden',
                          border: 'none',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                          cursor: produto.qtd > 0 ? 'pointer' : 'not-allowed',
                          opacity: produto.qtd > 0 ? 1 : 0.7
                        }}
onClick={() => {
  if (produto.qtd <= 0) {
    toast.warning(`Produto ${produto.descricao} sem estoque disponível`);
    return;
  }

  const clienteAtivo = pedidos.length > 0 && pedidos[0].nome && pedidos[0].nif;

if (produto.qtd <= 0) {
  toast.warning(`Produto ${produto.descricao} sem estoque disponível`);
  return;
}

if (clienteAtivo) {
 
  adicionarAoCarrinho(produto);
  setIsModalVisible(true); // abre carrinho para alterar quantidade/obs
} else {
  // Não existe cliente → escolhe cliente primeiro
  setProdutoSelecionado(produto);
  setIsEscolhaModalVisible(true);
 
}

}}

                        cover={
                          <div style={{ 
                            height: 140, 
                            overflow: 'hidden',
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                            <Image
                              src={produto.img || IMG_ALTERNATIVA}
                              fallback={IMG_ALTERNATIVA}
                              alt={produto.descricao}
                              style={{ 
                                width: '100%',
                                height: 'auto',
                                maxHeight: '100%',
                                objectFit: 'contain'
                              }}
                              preview={false}
                            />
                            <div style={{
                              position: 'absolute',
                              bottom: 8,
                              right: 8,
                              background: 'rgba(255,255,255,0.9)',
                              borderRadius: 20,
                              padding: '4px 12px',
                              fontWeight: 'bold',
                              color: '#333',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                              fontSize: '0.9rem'
                            }}>
                              {formatarValor(produto.preco || 0)}
                            </div>
                            {produto.qtd <= 0 && (
                              <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'rgba(0,0,0,0.5)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontWeight: 'bold'
                              }}>
                                ESGOTADO
                              </div>
                            )}
                          </div>
                        }
                      >
                        <div style={{ padding: '12px 0' }}>
                          <div style={{ 
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 8
                          }}>
                            <h3 style={{ 
                              margin: 0,
                              fontSize: '0.95rem',
                              fontWeight: 600,
                              color: '#333'
                            }}>
                              {produto.descricao}
                            </h3>
                          </div>

                          <div style={{ 
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 8
                          }}>
                           
                          </div>
                          
                          <Tag
                            style={{
                              background: 'rgba(45, 183, 245, 0.1)',
                              color: '#2db7f5',
                              borderRadius: 4,
                              border: 'none',
                              fontSize: '0.8rem'
                            }}
                          >
                            {categorias.find(c => c.id === produto.id_categoria)?.descricao || 'Sem categoria'}
                          </Tag>
                        </div>
                      </Card>
                    ))}
                  </div>
                  
                  {/* Paginação */}
                  <div style={{ 
                    marginTop: 24,
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                    <Pagination
                      current={currentPage}
                      pageSize={pageSize}
                      total={filteredProdutos.length}
                      onChange={(page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      }}
                      showSizeChanger
                      pageSizeOptions={['8', '12', '16', '24']}
                      showTotal={(total, range) => `${range[0]}-${range[1]} de ${total} itens`}
                    />
                  </div>
                </>
              ) : (
                <Empty
                  description={
                    <span style={{ color: 'rgba(0,0,0,0.5)' }}>
                      Nenhum produto disponível encontrado
                    </span>
                  }
                  style={{ 
                    marginTop: 30,
                    padding: 30,
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                  }}
                />
              )}
            </Spin>
          </Col>

          {/* Pedidos Ativos */}
          <Col {...responsiveLayout.ordersCol}>
            <Card
              title={
                <Space>
                  <FaClipboardList style={{ color: primaryColor }} />
                  <span>PEDIDOS ATIVOS</span>
                </Space>
              }
              style={{
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                marginBottom: 16
              }}
              extra={
                <Text strong style={{ color: primaryColor }}>
                  Total: {formatarValor(calcularTotalPedidosAtivos())}
                </Text>
              }
            >
              {pedidos.length > 0 ? (
                <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                  {pedidos.map(pedido => {
                    const produto = produtos.find(p => p.id === pedido.id_produto);
                    return (
                      <div key={pedido.id} style={{ marginBottom: 12 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Text strong style={{ fontSize: '0.9rem' }}>
                            {produto?.descricao || 'Produto não encontrado'}
                          </Text>
                          <Text style={{ fontSize: '0.9rem' }}>
                            {pedido.quantidade}x {formatarValor(produto?.preco || 0)}
                          </Text>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
                          <Text type="secondary" style={{ fontSize: '0.8rem' }}>
                            {pedido.obs || 'Sem observações'}
                          </Text>
                          {renderStatusTag(pedido.status)}
                        </div>
                        <Divider style={{ margin: '8px 0' }} />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <Empty
                  description="Nenhum pedido ativo"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              )}
            </Card>

            {/* Botão para Finalizar Pedido - Só aparece quando há pedidos ativos */}
            {pedidos.length > 0 && (
              <Card
                style={{
                  borderRadius: 12,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                  marginTop: 16,
                  border: `2px solid ${primaryColor}`
                }}
              >
                <div style={{ textAlign: 'center' }}>
                  <Text strong style={{ display: 'block', marginBottom: 12, fontSize: '16px' }}>
                    Total a Pagar: {formatarValor(calcularTotalPedidosAtivos())}
                  </Text>
                  <Button 
                    type="primary"
                    icon={<FaCheckCircle />}
                    onClick={finalizarPedidoComDocumento}
                    loading={finalizandoPedido}
                    style={{ 
                      background: gradient,
                      border: 'none',
                      borderRadius: 8,
                      boxShadow: '0 4px 12px rgba(247, 72, 115, 0.3)',
                      width: '100%',
                      height: 50,
                      fontSize: '1.1rem',
                      fontWeight: 'bold'
                    }}
                  >
                    {finalizandoPedido ? 'FINALIZANDO...' : 'FINALIZAR PEDIDO'}
                  </Button>
                </div>
              </Card>
            )}
          </Col>
        </Row>

        {/* Modal do Carrinho */}
        <Modal
          title={
            <span style={{
              background: gradient,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'inline-block'
            }}>
              FAZER PEDIDO - MESA {mesaId}
            </span>
          }
          open={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false);
            setStockError(null);
          }}
          footer={[
            <Button 
              key="cancel" 
              onClick={() => {
                setIsModalVisible(false);
                setStockError(null);
              }}
              style={{ borderRadius: 6 }}
            >
              Voltar
            </Button>,
            <Button 
              key="submit" 
              type="primary" 
              loading={loading}
              onClick={finalizarPedido}
              icon={<FaCheckCircle />}
              style={{ 
                background: gradient,
                border: 'none',
                borderRadius: 6,
                boxShadow: '0 2px 8px rgba(247, 72, 115, 0.3)'
              }}
            >
              Confirmar Pedido
            </Button>
          ]}
          width={window.innerWidth > 768 ? 600 : '90%'}
        >
          {stockError && (
            <Alert
              message="Erro de Estoque"
              description={
                <div>
                  <p>Não há quantidade suficiente em estoque para o produto <strong>{stockError.produto}</strong>.</p>
                  <p>Quantidade disponível: <strong>{stockError.disponivel}</strong></p>
                  <p>Quantidade solicitada: <strong>{stockError.solicitado}</strong></p>
                </div>
              }
              type="error"
              showIcon
              icon={<FaExclamationTriangle />}
              style={{ marginBottom: 16 }}
            />
          )}
          
          <div style={{ marginBottom: 24 }}>
            <h4 style={{ marginBottom: 8 }}>Itens do Pedido</h4>
            {carrinho.length > 0 ? (
              <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {carrinho.map(item => {
                  const produto = produtos.find(p => p.id === item.id);
                  const quantidadeDisponivel = produto ? produto.qtd : 0;
                  const excedeEstoque = item.quantidade > quantidadeDisponivel;
                  
                  return (
                    <div key={item.id} style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '8px 0',
                      borderBottom: '1px solid #f0f0f0',
                      backgroundColor: excedeEstoque ? '#fff2f0' : 'transparent'
                    }}>
                      <div style={{ flex: 2 }}>
                        <Text strong>{item.descricao}</Text>
                        {excedeEstoque && (
                          <div style={{ fontSize: '12px', color: '#ff4d4f' }}>
                            <FaExclamationTriangle /> Estoque insuficiente
                          </div>
                        )}
                      </div>
                      <div style={{ flex: 1, textAlign: 'right' }}>
                        <Space>
                          <Button 
                            size="small" 
                            onClick={(e) => {
                              e.stopPropagation();
                              removerDoCarrinho(item.id);
                            }}
                          >
                            -
                          </Button>
                          <Text type={excedeEstoque ? "danger" : undefined}>{item.quantidade}</Text>
                          <Button 
                            size="small" 
                            onClick={(e) => {
                              e.stopPropagation();
                              adicionarAoCarrinho(item);
                            }}
                            disabled={item.quantidade >= quantidadeDisponivel}
                          >
                            +
                          </Button>
                        </Space>
                      </div>
                      <div style={{ flex: 1, textAlign: 'right' }}>
                        <Text type={excedeEstoque ? "danger" : undefined}>
                          {formatarValor(item.preco * item.quantidade)}
                        </Text>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <Empty
                description="Nenhum item no carrinho"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            )}
          </div>

          <div style={{ marginBottom: 24 }}>
            <h4 style={{ marginBottom: 8 }}>Observações</h4>
            <Input.TextArea
              rows={3}
              placeholder="Ex: Sem cebola, bem passado, etc."
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              maxLength={255}
              showCount
            />
          </div>

          <Divider />

          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Text strong style={{ fontSize: 16 }}>Total:</Text>
            <Text strong style={{ fontSize: 18 }}>{formatarValor(calcularTotal())}</Text>
          </div>
        </Modal>

        {/* Modal para Gerar Fatura - FLUXO CORRETO */}
        <Modal
          title={
            <span style={{
              background: gradient,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'inline-block'
            }}>
              {faturaPronta ? 'FATURA PRONTA!' : 'GERAR FATURA'}
            </span>
          }
          open={isModalFaturaVisible}
          onCancel={fecharModalFatura}
          footer={[
            <Button 
              key="cancel" 
              onClick={fecharModalFatura}
              style={{ borderRadius: 6 }}
            >
              Fechar
            </Button>,
            !faturaPronta ? (
              <Button 
                key="validate" 
                type="primary" 
                loading={validandoFatura}
                onClick={validarEGerarFatura}
                icon={validandoFatura ? <FaSpinner /> : <FaFileDownload />}
                style={{ 
                  background: gradient,
                  border: 'none',
                  borderRadius: 6,
                  boxShadow: '0 2px 8px rgba(247, 72, 115, 0.3)'
                }}
              >
                {validandoFatura ? 'Validando...' : 'Validar e Gerar Fatura'}
              </Button>
            ) : (
              <Button 
                key="download" 
                type="primary" 
                onClick={abrirFatura}
                icon={<FaFileDownload />}
                style={{ 
                  background: '#52c41a',
                  border: 'none',
                  borderRadius: 6
                }}
              >
                Abrir Fatura
              </Button>
            )
          ]}
          width={window.innerWidth > 768 ? 500 : '90%'}
        >
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            {faturaPronta ? (
              <>
                <FaCheckCircle style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
                <Title level={4} style={{ marginBottom: '8px', color: '#52c41a' }}>
                  Fatura Gerada com Sucesso!
                </Title>
                <Text style={{ fontSize: '16px', color: '#666' }}>
                  O documento foi gerado com o número: <strong>#{documentoId}</strong>
                  <br />
                  Clique em "Abrir Fatura" para visualizar.
                </Text>
              </>
            ) : (
              <>
                <FaFileDownload style={{ fontSize: '48px', color: primaryColor, marginBottom: '16px' }} />
                <Title level={4} style={{ marginBottom: '8px' }}>
                  Validar Status da Fatura
                </Title>
                <Text style={{ fontSize: '16px', color: '#666', marginBottom: '16px' }}>
                  Clique em "Validar e Gerar Fatura" para verificar se a fatura está pronta.
                  <br />
                  O sistema irá consultar o status dos pedidos e gerar a fatura se estiverem FECHADOS.
                </Text>
                <Alert
                  message="Atenção"
                  description="A fatura só estará disponível quando todos os pedidos estiverem com status FECHADO."
                  type="info"
                  showIcon
                />
              </>
            )}
          </div>
        </Modal>

        {/* Modal de escolha do tipo de cliente */}
<Modal
  title="Selecionar tipo de cliente"
  open={isEscolhaModalVisible}
  onCancel={() => setIsEscolhaModalVisible(false)}
  footer={null}
  centered
>
  <Space direction="vertical" style={{ width: '100%' }}>
    <Button 
      type="primary" 
      block
      onClick={() => {
        adicionarAoCarrinho(produtoSelecionado);
        setIsEscolhaModalVisible(false);
      }}
    >
      Usar consumidor final
    </Button>

    <Button 
      block
      onClick={() => {
        setIsEscolhaModalVisible(false);
        setIsClienteModalVisible(true);
      }}
    >
      Inserir dados do cliente
    </Button>
  </Space>
</Modal>

{/* Modal para inserir dados do cliente */}
<Modal
  title="Inserir dados do cliente"
  open={isClienteModalVisible}
  onCancel={() => setIsClienteModalVisible(false)}
  footer={[
    <Button key="cancel" onClick={() => setIsClienteModalVisible(false)}>
      Cancelar
    </Button>,
    <Button 
      key="confirm" 
      type="primary" 
      onClick={() => {
        if (!nomeCliente || !nifCliente) {
          toast.error("Preencha o nome e o NIF");
          return;
        }

        Api.AddPedido({
          id_mesa: id,
          id_produto: produtoSelecionado.id,
          quantidade: 1,
          obs: observacao,
          status: 'ABERTO',
          token: tokenId,
          nome: nomeCliente,
          nif: nifCliente
        })
        .then(() => {
          toast.success('Pedido com dados do cliente adicionado!');
          fetchData();
          setIsClienteModalVisible(false);
          setNomeCliente('');
          setNifCliente('');
        })
        .catch((error) => {
          toast.error('Erro ao adicionar pedido: ' + error.message);
        });
      }}
    >
      Confirmar
    </Button>
  ]}
  centered
>
  <Space direction="vertical" style={{ width: '100%' }}>
    <Input 
      placeholder="Nome do cliente"
      value={nomeCliente}
      onChange={(e) => setNomeCliente(e.target.value)}
    />
    <Input 
      placeholder="NIF"
      value={nifCliente}
      onChange={(e) => setNifCliente(e.target.value)}
    />
  </Space>
</Modal>


        {/* Estilos para responsividade */}
        <style dangerouslySetInnerHTML={{ __html: `
          @media (max-width: 576px) {
            .hide-on-mobile {
              display: none;
            }
            .show-on-mobile {
              display: inline !important;
            }
          }
        ` }} />
      </div>
    </ConfigProvider>
  );
};

export default TelaVendas;